import React, { FC, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AnyAction } from 'redux'
import {
    Drawer,
    Form,
    Button,
    Col,
    Row,
    Input,
    Space,
    Divider,
    Select
} from 'antd'
import { toast } from 'react-toastify'
import PrefixService from "../../../services/prefix"
import { requestAuthInit } from '../../../store/auth/auth.actions'
import { AddBankParams } from '../../../@types/prefix'
import { ThunkDispatch } from '../../../@types/store'
import PatternNumber from '../../../utils/PatternNumber'

interface AddBankProps {
    close: () => void
    isOpen: boolean
}

const AddBank: FC<AddBankProps> = ({ close, isOpen }) => {
    const [form] = Form.useForm();
    const title = "เพิ่มบัญชีธนาคาร"
    const { Option } = Select
    const [btnLoading, setBtnLoading] = useState(false)
    const dispatch: ThunkDispatch<AnyAction> = useDispatch()

    const insertData = async (values: AddBankParams) => {
        try {
            const res = await PrefixService.addBankAccount(values)
            setBtnLoading(false)
            dispatch(requestAuthInit(false))
            toast.success(res.message)
            close()
        } catch ({ message }) {
            toast.error(message as string)
            setBtnLoading(false)
        }
    }

    const handleFormSubmit = () => {
        form.validateFields()
            .then((values: AddBankParams) => {
                setBtnLoading(true)
                insertData(values)
            })
            .catch((errorInfo) => { });
    };


    useEffect(() => {
        if (form && isOpen) {
            form.resetFields();
        }
    }, [form, isOpen]);

    return (
        <>
            <Drawer
                title={title}
                onClose={close}
                visible={isOpen}
                bodyStyle={{ paddingBottom: 80 }}
                width={global.window.innerWidth <= 1200 ? global.window.innerWidth : global.window.innerWidth * .4}
                extra={
                    <Space>
                        <Button
                            onClick={handleFormSubmit}
                            type="primary"
                            loading={btnLoading}
                            size="large">
                            <i className="fa-solid fa-save me-2"></i>
                            บันทึก
                        </Button>
                    </Space>
                }>
                <Form
                    form={form}
                    name="AddBank"
                    layout="vertical"
                    hideRequiredMark>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                name="accountName"
                                label="ชื่อบัญชี"
                                rules={[{ required: true, message: 'กรุณากรอกชื่อบัญชี' }]}
                                hasFeedback>
                                <Input placeholder="ชื่อบัญชี" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                name="accountNumber"
                                label="เลขที่บัญชี"
                                rules={[{ required: true, message: 'กรุณากรอกเลขที่บัญชี' }, { pattern: PatternNumber, message: 'กรุณากรอกเป็นตัวเลขเท่านั้น' }]}
                                hasFeedback>
                                <Input placeholder="เลขที่บัญชี" inputMode='numeric' />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                name="bank"
                                label="ธนาคาร"
                                rules={[{ required: true, message: 'กรุณาเลือกธนาคาร' }]}
                                hasFeedback>
                                <Select
                                    placeholder="เลือกธนาคาร"
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input: any, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }>
                                    <Option key={'scb'} value={'scb'}>ธนาคารไทยพาณิชย์</Option>
                                    <Option key={'kbank'} value={'kbank'}>ธนาคารกสิกรไทย</Option>
                                    {/* <Option key={'bay'} value={'bay'}>ธนาคารกรุงศรีอยุธยา</Option> */}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider />
                    <div className="drawer-actions">
                        <Space>
                            <Button type="primary" htmlType="submit" disabled={btnLoading} onClick={handleFormSubmit} size="large"><i className="fa-solid fa-save me-2"></i> บันทึก</Button>
                            <Button onClick={close} size="large">ยกเลิก</Button>
                        </Space>
                    </div>
                </Form>
            </Drawer>
        </>
    )
}
export default AddBank

